<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Making Teca', route: '/backoffice/making-teca/' }, { label: 'Modifica Post', active: true }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">Modifica post</h1>
</section>

<section class="px-container pb-16">
    <form [formGroup]="formPost" class="accrediti-form flex flex-col gap-6" (ngSubmit)="onSubmit()">
        <div class="ac-section-head">
            <h2>Dati post</h2>
            <span class="ac-meta">titolo, data e immagine di copertina</span>
        </div>

        <div class="flex lg:flex-row flex-col gap-4">
            <div class="fld flex-1">
                <label>* Titolo</label>
                <input type="text" pInputText class="w-full" placeholder="Titolo" formControlName="titolo" required />
                <small class="text-red-600 block mt-2 font-medium" *ngIf="formPost.get('titolo')?.hasError('required') && (formPost.get('titolo')?.dirty || formPost.get('titolo')?.touched)">Il titolo è obbligatorio.</small>
            </div>
            <div class="fld flex-1">
                <label>* Data</label>
                <p-calendar formControlName="data" placeholder="Data" dateFormat="dd/mm/yy" [showIcon]="true" styleClass="w-full" appendTo="body" />
                <small class="text-red-600 block mt-2 font-medium" *ngIf="formPost.get('data')?.hasError('required') && (formPost.get('data')?.dirty || formPost.get('data')?.touched)">La data è obbligatoria.</small>
            </div>
        </div>

        <div class="flex lg:flex-row flex-col gap-4 items-start">
            <div class="fld flex-1">
                <app-file-upload [form]="formPost" [control]="'immagine'" [label]="'* Immagine box'" [multiple]="false" [accept]="'image/*'" [text]="'Seleziona un\'immagine'" (load)="onImmagineUpload($event)"></app-file-upload>
            </div>
            <div class="flex-1" *ngIf="making_teca_post?.immagine!.length > 0">
                <button class="acc-btn" type="button" (click)="show_image = !show_image">{{show_image ? 'Nascondi' : 'Mostra'}} immagine caricata</button>
                <img [src]="(making_teca_post?.immagine + '?type=making-teca' | image)" alt="Immagine post" *ngIf="show_image" class="mt-4 max-w-full rounded">
            </div>
        </div>

        <div class="ac-section-head mt-2">
            <h2>Contenuti</h2>
            <span class="ac-meta">sezioni del post</span>
        </div>

        <ng-container *ngFor="let data of making_teca_post_data; let i = index">
            <div class="flex flex-col gap-4 pt-4 border-t border-[var(--acc-line,#e3dcce)]">
                <div class="fld">
                    <label>* Titolo</label>
                    <input type="text" pInputText class="w-full" placeholder="Titolo" [formControlName]="'titolo_' + i" required />
                </div>
                <div class="fld">
                    <label>Descrizione</label>
                    <p-editor [style]="{ height: '150px' }" [formControlName]="'descrizione_' + i" />
                </div>
                <div class="flex lg:flex-row flex-col gap-4 items-start">
                    <div class="fld flex-1">
                        <app-file-upload [form]="formPost" [control]="'immagine_' + i" [label]="'Immagine contenuto'" [multiple]="false" [accept]="'image/*'" [text]="'Seleziona un\'immagine'" (load)="onImmagineContenutoUpload($event, i)"></app-file-upload>
                    </div>
                    <div class="flex-1" *ngIf="data.immagine.length > 0">
                        <button class="acc-btn" type="button" (click)="data.show_immagine = !data.show_immagine">{{data.show_immagine ? 'Nascondi' : 'Mostra'}} immagine caricata</button>
                        <img [src]="(data?.immagine + '?type=making-teca' | image)" alt="Immagine contenuto" *ngIf="data.show_immagine" class="mt-4 max-w-full rounded">
                    </div>
                </div>
                <div class="flex justify-end">
                    <button class="acc-btn acc-btn-ghost" type="button" (click)="onRemoveContenuto(i)">Rimuovi contenuto</button>
                </div>
            </div>
        </ng-container>

        <div class="acc-actions">
            <button class="acc-btn" type="button" (click)="onAddContenuto()">Aggiungi contenuto</button>
            <p-confirmPopup #confirmDeletePopupRef>
                <ng-template pTemplate="headless" let-message>
                    <div class="border-round p-3">
                        <span class="text-base">{{ message.message }}</span>
                        <div class="flex align-items-center gap-2 mt-3">
                            <button type="button" class="acc-btn flex-1" (click)="onDelete()">Elimina</button>
                            <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnulla()">Annulla</button>
                        </div>
                    </div>
                </ng-template>
            </p-confirmPopup>
            <button class="acc-btn" type="button" (click)="onDeletePostPopup($event)">Elimina post</button>
            <a class="acc-btn acc-btn-ghost" routerLink="/backoffice/making-teca">Annulla</a>
            <button class="acc-btn acc-btn-primary" type="submit" [disabled]="!formPost.valid">Salva modifiche</button>
        </div>
    </form>
</section>
